export class AzureListSubscriptionsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "tenants",
            "baseName": "tenants",
            "type": "Array<AzureTenant>",
            "format": ""
        },
        {
            "name": "managementGroups",
            "baseName": "managementGroups",
            "type": "Array<AzureManagementGroup>",
            "format": ""
        },
        {
            "name": "subscriptions",
            "baseName": "subscriptions",
            "type": "Array<AzureSubscription>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureListSubscriptionsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
